import { render, staticRenderFns } from "./PepperRodeo.vue?vue&type=template&id=18019667&"
import script from "./PepperRodeo.vue?vue&type=script&lang=js&"
export * from "./PepperRodeo.vue?vue&type=script&lang=js&"
import style0 from "./PepperRodeo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports